import { useEffect, useRef } from "react";
import { Fragment, useState } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import {
  setDataInRedux,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
} from "../../actions/CommonAction";
import { BiBarChartAlt2, BiConfused, BiBell } from "react-icons/bi";
import { RxEnvelopeClosed } from "react-icons/rx";
import { FiPhoneCall } from "react-icons/fi";
import { BsCircleFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { AiOutlineLogout } from "react-icons/ai";
import userIcon from "../../assets/images/icons8-user-50.png";
import maleUserIcon from "../../assets/images/user-male.jpeg";
import femaleUserIcon from "../../assets/images/user-female.jpeg";
import WebService from "../../utility/WebService";
import WarningModal from "../Warning/Warning";
import { NavLink } from "react-router-dom";
import SucessModal from "../SucessModal/Sucess";
import { FiChevronDown } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import HelperService from "../../utility/HelperService";
import { IoAlert } from "react-icons/io5";
import { Trash3Fill, X } from "react-bootstrap-icons";
import { GrClose } from "react-icons/gr";
import { toast } from "react-hot-toast";
import htmlparse from "html-react-parser";
import SpringMoneyApiEndPoints from "../SpringMoney/SpringMoneyApiEndPoints";
import Loader from "../Loader/Loader";
import BrokerSelectionPopup from "../SpringMoney/Transactions/BrokerSelectionPopup";
import LogoutPopup from "../SpringMoney/Transactions/LogoutPopup";
const userNavigation = [
  { name: "Deo Dashboard", href: "", isShow: false },
  {
    name: "Two Factor Authentication(2FA)",
    href: "/my-profile",
    isShow: false,
  },
  { name: "Agreement", href: "/admin/mis-report/agreement", isShow: false },
  { name: "Change Password", href: "/change-password", isShow: false },
  { name: "Sign out", href: "#", isShow: false },
];

const NotificatonDropList = [
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "25 Nov 2022",
    href: "#",
  },
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "30 Nov 2022",
    href: "#",
  },
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "4 Dec 2022",
    href: "#",
  },
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "7 Dec 2022",
    href: "#",
  },
  {
    name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "10 Dec 2022",
    href: "#",
  },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const Header = (props: any) => {
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState<any>();
  const [ShowLoader, setShowLoader] = useState(false);
  const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");
  const dispatch: Dispatch<any> = useDispatch();
  const [warningMessage, setWarningMessage] = useState<any>();
  const [isShowWarningModal, setShowWarningModal] = useState(false);
  const [isDeoDashboard, setIsDeoDashboard] = useState(false);
  const [sucessMessage, setSucessMessage] = useState<any>();
  const [isShowSucessModal, setShowSucessModal] = useState(false);
  const [announcementCount, setAnnouncementCount] = useState<any>();
  const [notification, setNotification] = useState<any>();
  const [navigation, setNavigation] = useState<any>([]);
  const [notificationCount, setNotificationCount] = useState<any>();
  const [image, setImage] = useState<any>();
  const [totalCount, setTotalCount] = useState<any>(0);
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);
  const [checkAgreementData, setCheckAgreementData] = useState<any>();
  const [companyImageURL, setCompanyImageURL] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [showSafehandsLogoLoading, setShowSafehandsLogoLoading] =
    useState<boolean>(false);
  const [isCinet, setIsCinet] = useState(false);
  const [showBrokerSelectionPopup, setShowBrokerSelectionPopup] =
    useState<boolean>(false);
  const [brokerList, setBrokerList] = useState<any>();
  const [smallCaseNotificationDetails, setSmallCaseNotificationDetails] =
    useState<any>();
  const [logoutFromPrevBroker, setLogoutFromPrevBroker] = useState<string>();
  const [showBrokerLogoutPopup, setShowBrokerLogoutPopup] =
    useState<boolean>(false);

  let history = useNavigate();

  const SignOut = () => {
    localStorage.clear();
    dispatch(setDataInRedux({ type: USER_LOGOUT, value: "" }));
    window.location.href = "/login";
  };

  const handleLeftSideBar = () => {
    props.setIsSidebarVisible(true);
  };

  useEffect(() => {
    CheckDisplay();
    getAnnouncements();
    getList();
    getNotification();
    getCompanyDetail();

    {
      user_data.is_person == "Client" && checkAgreement();
    }

    for (var i in userNavigation) {
      if (user_data.is_person == "Admin") {
        if (userNavigation[i].name == "Sign out") {
          userNavigation[i].isShow = true;
        }
      } else {
        userNavigation[i].isShow = true;
      }
    }
    setNavigation([...userNavigation]);
  }, []);
  const checkAgreement = () => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/v2/ClientAgreements/IsAgreementSigned`,
      body: null,
    })
      .then((res: any) => {
        setShowLoader(false);
        if (res.is_signed_agreement == false) {
          //setOpen(true);
        }
        setCheckAgreementData(res);
      })
      .catch((e) => {
        setShowLoader(false);
        // setWarningMessage(e.response.data.message)
      });
  };

  const getAnnouncements = () => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/v2/Announcements/GetActiveAnnouncements`,
      body: null,
    })
      .then((res: any) => {
        setAnnouncementCount(res.total_count);
        setAnnouncements(res.list);
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
        // setWarningMessage(e.response.data.message)
      });
  };

  const warningCloseModal = () => {
    setShowWarningModal(false);
    setShowLoader(false);
  };

  const getList = (page?: any) => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/v2/Discrepancy/GetDiscrepancies`,
      body: null,
    })
      .then((res: any) => {
        setTotalCount(res.total_count);
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
      });
  };

  // const getNotification = () => {
  //     setShowLoader(true)
  //     WebService.getAPI({
  //         action: `/v2/Dashboard/GetAlerts`,
  //         body: null
  //     })
  //         .then((res: any) => {
  //             setNotificationCount(res.total_count)
  //             setNotification(res.list)
  //             setShowLoader(false)
  //         })
  //         .catch((e) => {
  //             setShowLoader(false)
  //             // setWarningMessage(e.response.data.message)
  //         })
  // }

  const getNotification = () => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/v2/NotificationDetails/GetNotifications`,
      body: null,
    })
      .then((res: any) => {
        setNotificationCount(res.total_count);
        setNotification(res.list);
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
        // setWarningMessage(e.response.data.message)
      });
  };

  // const sucessCloseModal = () => {
  //     setShowSucessModal(false)
  //     setShowLoader(false);
  //   }

  const onMyProfile = () => {
    navigate("/my-profile");
  };
  const onAgreement = () => {
    navigate("/admin/mis-report/agreement");
  };

  const onChangePassword = () => {
    navigate("/change-password");
  };
  const CheckDisplay = () => {
    var token: any = localStorage.getItem("token_pre");
    const userDetailString = localStorage.getItem("user_Detail");
    if (userDetailString) {
      const userDetail = JSON.parse(userDetailString);
      const roles = userDetail.roles;
      if (roles.some((role: any) => role.name === "Financial Planning")) {
        setIsCinet(true);
      }
    }
    if (token) {
      setIsDeoDashboard(true);
    } else {
      setIsDeoDashboard(false);
    }
  };
  const goToDeoDashboard = () => {
    var token: any = localStorage.getItem("token_pre");
    localStorage.setItem("token", token);
    localStorage.removeItem("token_pre");
    onLoginDetail(token);
  };

  const onLoginDetail = (token?: any) => {
    WebService.getAPI({
      action: `/login/me`,
    })
      .then((res: any) => {
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload: { access_token: token },
        });
        localStorage.setItem("user_Detail", JSON.stringify(res.result));
        history("/dashboard");
        window.location.reload();
      })
      .catch((e) => {
        // setLoading(false)
      });
  };

  const DeleteNotification = (index: any) => {
    console.log(index);
    WebService.getAPI({
      action: `/v2/NotificationDetails/ArchiveNotification?id=${index}`,
      body: null,
    })
      .then((res: any) => {
        getNotification();
        ReadNotification(notification);
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
      });
  };

  const ReadNotification = (list: any) => {
    var temp = [];
    for (var i in list) {
      temp.push(notification[i].id);
    }
    console.log(temp);
    WebService.postAPI({
      action: `/v2/NotificationDetails/ReadNotification`,
      body: temp,
    })
      .then((res: any) => {
        getNotification();
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
      });
  };
  const onCloseModal = () => {
    history(`/admin/mis-report/agreement`);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const getCompanyDetail = () => {
    WebService.getAPI({
      action: `/CompanyMaster/CompanyDetail`,
    })
      .then((res: any) => {
        if (res) {
          if (res.image_path) {
            setCompanyImageURL(res.image_path);
          }
          setCompanyName(res.name_of_company);
        }
        setShowLoader(false);
      })
      .catch((e) => {
        setShowLoader(false);
      });
  };

  const handleNotification = (notification: any) => {
    if (notification.title_name === "Smallcase") {
      setSmallCaseNotificationDetails(notification);
      // setShowBrokerLogoutPopup(true);
    }
  };

  useEffect(() => {
    if (smallCaseNotificationDetails) {
      // getBrokerListCallApi();
      jwtTokenApi();
    }
  }, [smallCaseNotificationDetails]);

  const jwtTokenApi = async () => {
    // setShowBrokerSelectionPopup(false);
    setShowSafehandsLogoLoading(true);
    const investor_id = smallCaseNotificationDetails.investor_id;
    try {
      const response = await fetch(
        `${SpringMoneyApiEndPoints.authIdAgainstInvestorId}${investor_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (data.status_code === 200) {
        setShowSafehandsLogoLoading(false);
        fetchTransactionIdApiCall(data.data);
      } else {
        setShowSafehandsLogoLoading(false);
        toast.error("error_occured, Try Again");
      }
    } catch (err) {
      setShowSafehandsLogoLoading(false);
      toast.error("error_occured, Try Again");
    }
  };

  const fetchTransactionIdApiCall = async (JwtToken: any) => {
    setShowSafehandsLogoLoading(true);
    try {
      const response = await fetch(
        `${SpringMoneyApiEndPoints.fetchTransactionIdBySpTransactionId}`,
        {
          method: "POST",
          body: JSON.stringify({
            sp_transaction_id: smallCaseNotificationDetails.sp_transaction_id,
            gateway_auth_token: JwtToken.token,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (data.status_code === 200) {
        setShowSafehandsLogoLoading(false);
        sendTransactionIdToSafehandsBackend(
          JSON.parse(smallCaseNotificationDetails.customer_advice_details_id),
          data.data.transaction_id
        );
        smallCaseSdkTrigger(JwtToken, data.data);
      } else {
        setShowSafehandsLogoLoading(false);
        toast.error("error_occured,Try Again");
      }
    } catch (err) {
      setShowSafehandsLogoLoading(false);
      toast.error("error_occured,Try Again");
    }
  };

  const smallCaseSdkTrigger = async (
    JwtToken: any,
    TransactionIdApiResponse: any
  ) => {
    const gatewayInstance = new window.scDK({
      gateway: "plan360degree",
      smallcaseAuthToken: `${JwtToken.token}`,
      config: {
        amo: false,
      },
    });

    gatewayInstance.init({ smallcaseAuthToken: JwtToken.token });
    if (JwtToken.user_type === "connected_user") {
      await gatewayInstance.brokerLogout();
    }

    gatewayInstance
      .triggerTransaction({
        transactionId: `${TransactionIdApiResponse.transaction_id}`,
        // brokers: ["kite", "angelbroking", "icici", "hdfc", "kotak", "motilal"],
      })
      .then((txnResponse: any) => {
        SmallCaseResponseSend(txnResponse);
        DeleteNotification(smallCaseNotificationDetails.id);
      })
      .catch((err: any) => {
        addErrorFromSmallCaseSdkApiCall(
          JSON.parse(smallCaseNotificationDetails.customer_advice_details_id),
          err.message
        );
        // DeleteNotification(smallCaseNotificationDetails.id);
        toast.error(err.message);
      });
  };

  const sendTransactionIdToSafehandsBackend = (
    customer_advise_details_ids: any,
    transaction_id: any
  ) => {
    WebService.postAPI({
      action: `/v2/ShareTransactionBufferDetails/RtaId`,
      body: JSON.stringify({
        customer_advice_details_id: customer_advise_details_ids,
        rta_id: transaction_id,
      }),
    })
      .then((res: any) => {
        setShowSafehandsLogoLoading(false);
      })
      .catch((e) => {
        setShowSafehandsLogoLoading(false);
      });
  };

  const addErrorFromSmallCaseSdkApiCall = (
    customer_advise_details_id: any,
    message: any
  ) => {
    setShowSafehandsLogoLoading(true);
    WebService.postAPI({
      action: `/v2/ShareTransactionBufferDetails/AddError`,
      body: JSON.stringify({
        customer_advice_details_id: customer_advise_details_id,
        comments: message,
      }),
    })
      .then((res: any) => {
        setShowSafehandsLogoLoading(false);
      })
      .catch((e) => {
        setShowSafehandsLogoLoading(false);
      });
  };

  const SmallCaseResponseSend = async (res: any) => {
    const reponse = await fetch(SpringMoneyApiEndPoints.userVerificationApi, {
      method: "POST",
      body: JSON.stringify({
        transaction_id: res.transactionId,
        broker: res.broker,
        smallcase_auth_token: res.smallcaseAuthToken,
        investor_id: `${smallCaseNotificationDetails.investor_id}`,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  return (
    <>
      {showBrokerLogoutPopup && (
        <div className="fixed w-[100%] h-[100%] top-0 left-0 flex justify-center items-center z-[1000] bg-[#00000080]">
          <div className="max-h-[90vh] overflow-y-auto">
            <LogoutPopup
              setLogoutFromPrevBroker={setLogoutFromPrevBroker}
              setShowBrokerLogoutPopup={setShowBrokerLogoutPopup}
            />
          </div>
        </div>
      )}
      <Loader show={showSafehandsLogoLoading} />
      {/* <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            /> */}
      <WarningModal
        show={isShowWarningModal}
        isClose={warningCloseModal}
        message={warningMessage}
      />
      <div className="sticky top-0 z-10 flex h-16 flex-shrink-0  bg-white drop-shadow-[8px_3px_5px_rgba(0,0,0,0.050)] items-center app-header">
        <div className="flex flex-1 justify-between items-center px-8">
          <div className="mr-[4px] cursor-pointer" onClick={handleLeftSideBar}>
            <img width={34} src="/images/menu.svg" />
          </div>
          <div
            id="update-count"
            // className="mr-3"
            className="mr-1"
            onClick={() => getList()}
          ></div>
          <div
            id="update-company-logo-img"
            // className="mr-3"
            className="mr-1"
            onClick={() => onLoginDetail()}
          ></div>
          <div
            id="update-profile-img"
            // className="mr-3"
            className="mr-1"
            onClick={() => onLoginDetail()}
          ></div>
          <div className="flex flex-1 items-center">
            {/* <div className="mr-3 ml-[48px]">
                            <img src={user_data?.company_image ? user_data?.company_image : "/images/short-logo.svg"} className="image_size" />
                        </div>  */}
            {companyImageURL && (
              <div className="mr-3 ml-2">
                <img
                  src={companyImageURL}
                  //  alt="logo"
                  height={"80px"}
                  // width={"auto"}
                  width={"80px"}
                  className=""
                />
              </div>
            )}
            <div>
              <h3 className=" font-semibold text-lg">
                {user_data?.company_details?.company_name
                  ? user_data?.company_details?.company_name
                  : "-"}
              </h3>
              <p className="flex items-center text-[#7C7C7C]">
                <span className=" text-[14px] flex items-center mr-3">
                  <RxEnvelopeClosed size={14} className="mr-1" />
                  {user_data?.company_details?.email
                    ? user_data?.company_details?.email
                    : "-"}
                </span>
                <span className=" text-[14px] flex items-center">
                  <FiPhoneCall size={14} className="mr-1" />{" "}
                  {user_data?.company_details?.mobile_no
                    ? user_data?.company_details?.mobile_no
                    : "-"}
                </span>
              </p>
            </div>
          </div>
          <div className="ml-4 flex items-center md:ml-6">
            <button
              type="button"
              className="hidden mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 "
              onClick={() => SignOut()}
            >
              <span className="sr-only">View notifications 2</span>
              <span className="notification-bage">
                <AiOutlineLogout size={22} className="icon" />
              </span>
              <span className="header-likn-text">Sign Out</span>
            </button>
            {user_data.is_person == "Client" && (
              <>
                {/* <button
                                    onClick={handleSmallCaseCall}
                                    type="button"
                                    className=" mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 "
                                >
                                    <span className="notification-bage">
                                        <img width={40} height={40} src="/images/smallcase.webp" />
                                    </span>
                                    <div>
                                        <span className="header-likn-text">smallcase</span>
                                    </div>
                                </button> */}
                <button
                  onClick={() => history(`/action/my-document`)}
                  type="button"
                  className=" mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 "
                >
                  <span className="sr-only">View notifications 2</span>
                  <span className="notification-bage">
                    <svg className="icon inline  " width={20} height={20}>
                      <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#icon-folder"></use>
                    </svg>
                  </span>
                  <div>
                    <NavLink to="/action/my-document">
                      <span className="header-likn-text">Documents</span>
                    </NavLink>
                  </div>
                </button>
                {user_data.client_type == "individual" && (
                <button
                  onClick={() => history(`/discrepancies`)}
                  type="button"
                  className="  mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 "
                >
                  <span className="sr-only">View notifications 1</span>
                  <span className="notification-bage">
                    <span className="notification-count count-dsicrp">
                      {totalCount}
                    </span>

                    <svg className="icon inline mr-2" width={25} height={20}>
                      <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#icon-noti-x"></use>
                    </svg>
                  </span>
                  <div>
                    <NavLink to="/discrepancies">
                      <span className="header-likn-text">Discrepancies</span>
                    </NavLink>
                  </div>
                </button>
                )}
              </>
            )}
            {/* <button
                            type="button"
                            className=" mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 "
                        >
                            <span className="sr-only">View notifications 3</span>
                            <span className="notification-bage">
                                 
                                <svg className="icon inline  " width={20} height={20} >
                                    <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#icon-calendar"></use>
                                </svg>
                            </span>
                            <span className="header-likn-text">Calender</span>
                        </button> */}
            {/* <button
                            type="button"
                            className=" mr-4 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500"
                        >
                            <span className="sr-only">View notifications</span>
                            <span className="notification-bage">
                                <span className="notification-count">10</span>
                               
                                <svg className="icon inline  " width={20} height={20} >
                                    <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#icon-message"></use>
                                </svg>
                            </span>
                            <span className="header-likn-text">Chat</span>
                           
                        </button> */}

            {/* Announcement DropDown */}

            <Menu as="div" className="relative ml-3">
              <div>
                <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm mx-auto">
                  <span className="sr-only">Open user menu</span>
                  <span className="notification-bage">
                    <span className="notification-count">
                      {announcementCount ? announcementCount : 0}
                    </span>
                    <svg className="icon inline  " width={20} height={22}>
                      <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#anouce"></use>
                    </svg>
                  </span>
                </Menu.Button>
                <span className="header-likn-text">Announcements</span>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  w-[500px]">
                  <div className="bg-[#E9DEFF] p-3 rounded-t-lg">
                    <span className="text-[16px] font-semibold">
                      Announcements
                    </span>
                  </div>
                  {announcements?.map((item: any) => (
                    <Menu.Item key={item.name}>
                      {({ active }) => (
                        <a
                          href={item.href}
                          className={classNames(
                            active ? "bg-gray-100" : "",
                            "block px-4 py-2 text-sm text-gray-700"
                          )}
                        >
                          <div className="flex justify-between items-center">
                            <span className="text-[12px] text-gray-400">
                              {item.start_date
                                ? HelperService.getFormatedDateByDMYwith(
                                    item.start_date
                                  )
                                : "-"}
                            </span>
                            <span className="text-brand">
                              {" "}
                              <BsCircleFill size={10} />
                            </span>
                          </div>
                          <span style={{ fontWeight: "bold" }}>
                            {item.title ? item.title : "-"}
                          </span>{" "}
                          <br></br>
                          {item.content ? item.content : "-"}
                        </a>
                      )}
                    </Menu.Item>
                  ))}
                  {announcements?.length == 0 && ShowLoader == false && (
                    <div>
                      <div className="error-message-table">
                        No Announcements Found
                      </div>
                    </div>
                  )}
                </Menu.Items>
              </Transition>
            </Menu>

            {/* Notification dropdown */}
            <Menu as="div" className="relative ml-3">
              <div>
                <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm mx-auto">
                  <span className="sr-only">Open user menu</span>
                  <span className="notification-bage">
                    <span className="notification-count">
                      {notificationCount ? notificationCount : 0}
                    </span>
                    <svg
                      className="icon inline  "
                      width={20}
                      height={22}
                      onClick={() => {
                        ReadNotification(notification);
                      }}
                    >
                      <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#bell"></use>
                    </svg>
                  </span>
                </Menu.Button>
                <span className="header-likn-text">Notification</span>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-30 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  w-[400px]">
                  <div className="bg-[#E9DEFF] p-3 rounded-t-lg">
                    <span className="text-[16px] font-semibold">
                      Notifications
                    </span>
                  </div>
                  {/* {notification?.length > 0 && notification.map((item: any) => (
                                        <Menu.Item key={item.description}>

                                            {({ active }) => (
                                                <a
                                                    href={item.href}
                                                    className={classNames(
                                                        active ? 'bg-gray-100' : '',
                                                        'block px-4 py-2 text-sm text-gray-700'
                                                    )}
                                                >
                                                    <div className="flex justify-between items-center">
                                                        <span className="text-[15px] " style={{ color: item.color }}>{item.description ? item.description : "-"}</span>
                                                        <span className="text-brand"> <BsCircleFill size={10} style={{ color: item.color }} /></span>
                                                    </div>
                                                    <p style={{ color: item.color }}>{item.expiry_date ? HelperService.getFormatedDateByDMYwith(item.expiry_date) : "-"}</p>

                                                </a>
                                            )}
                                        </Menu.Item>
                                    ))} */}

                  {notification?.length > 0 &&
                    notification.map((item: any) => (
                      <Menu.Item key={item.title_name}>
                        {({ active }) => (
                          <div className="">
                            <a
                              href={"#"}
                              className={classNames(
                                active ? "bg-gray-100" : "",
                                "block px-4 py-2 text-sm text-gray-700"
                              )}
                            >
                              <div className="flex justify-between items-center ">
                                <span
                                  onClick={() => handleNotification(item)}
                                  className="text-[15px] "
                                  style={{ color: "black" }}
                                >
                                  {item.title_name}
                                </span>
                                <span className="text-brand closebtn">
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="block"
                                    aria-label="Close"
                                    onClick={() => {
                                      DeleteNotification(item.id);
                                    }}
                                  >
                                    <GrClose size={12} />
                                  </button>
                                </span>
                              </div>
                              <p onClick={() => handleNotification(item)}>
                                {htmlparse(item.message)}
                              </p>
                            </a>
                          </div>
                        )}
                      </Menu.Item>
                    ))}
                  {notification?.length == 0 && ShowLoader == false && (
                    <div>
                      <div className="error-message-table">
                        No Notifications Found
                      </div>
                    </div>
                  )}
                </Menu.Items>
              </Transition>
            </Menu>

            {/* Profile dropdown */}
            {
              <Menu as="div" className="relative ml-3">
                <div>
                  <Menu.Button className="max-w-xs items-center rounded-full bg-white text-sm  ring-offset-0 p-1 mb-3">
                    {/*border border-indigo-500 */}
                    <span className="sr-only">Open user menu</span>
                    <img
                      className="rounded-full object-cover h-[50px] w-[50px]"
                      src={
                        user_data.user_image ? user_data.user_image : user_data.gender ? (user_data.gender == "Male" ? maleUserIcon : femaleUserIcon) : userIcon
                      }
                    />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {navigation.map((item: any) => (
                      <Menu.Item key={item.name}>
                        {({ active }) => (
                          <>
                            {item.name != "Deo Dashboard" &&
                              item.name != "Agreement" &&
                              item.isShow && (
                                <div
                                  onClick={() =>
                                    item.name == "Sign out"
                                      ? SignOut()
                                      : item.name ==
                                        "Two Factor Authentication(2FA)"
                                      ? onMyProfile()
                                      : item.name == "Change Password"
                                      ? onChangePassword()
                                      : ""
                                  }
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700 cursor-pointer"
                                  )}
                                >
                                  {item.name}
                                </div>
                              )}

                            {isDeoDashboard &&
                              item.name == "Deo Dashboard" &&
                              item.isShow && (
                                <div
                                  onClick={() => goToDeoDashboard()}
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700 cursor-pointer"
                                  )}
                                >
                                  {item.name}
                                </div>
                              )}
                            {(isDeoDashboard || isCinet) &&
                              item.name == "Agreement" &&
                              item.isShow && (
                                <div
                                  onClick={() => onAgreement()}
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700 cursor-pointer"
                                  )}
                                >
                                  {item.name}
                                </div>
                              )}
                          </>
                        )}
                      </Menu.Item>
                    ))}
                  </Menu.Items>
                </Transition>
              </Menu>
            }
          </div>
        </div>
      </div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className="relative transform  rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all mt-8"
                  style={{ padding: "50px" }}
                >
                  {/* <div> */}
                  {/* <div className="agreementPopUpClose">
                                        <X size={30} onClick={handleClose} />
                                    </div> */}
                  <div>
                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                      <IoAlert
                        className="h-6 w-6 text-red-700"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-5">
                      <Dialog.Title
                        as="h3"
                        className="text-base font-semibold leading-6 text-red-500"
                      >
                        Alert
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          {checkAgreementData?.message}
                        </p>
                      </div>
                    </div>
                  </div>
                  {checkAgreementData?.id && (
                    <div className="mt-5 flex justify-center">
                      <button
                        type="button"
                        className="btn btn-brand-outline mr-3 w-32"
                        onClick={() => onCloseModal()}
                      >
                        {checkAgreementData?.button_title}
                      </button>
                      <button
                        type="button"
                        className="btn btn-brand-outline mr-3 w-32"
                        onClick={() => handleClose()}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default Header;
